import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://gasflow.africa/v1/api'
  // baseURL: 'http://localhost:3000' // development
});

const authUser = localStorage.getItem('user');

let token = '';

if (authUser) {
  token = JSON.parse(authUser).accessToken;
}

instance.defaults.headers.common.Authorization = `Bearer ${token}`;

instance.interceptors.request.use(
  (request) => {
    const mainUser = localStorage.getItem('user');
    let mainToken = '';
    if (mainUser) {
      mainToken = JSON.parse(mainUser).accessToken;
    }
    // // request.headers.common.Authorization = `Bearer ${mainToken}`;
    request.headers['Authorization'] = `Bearer ${mainToken}`;
    return request;
  },
  (error) => {
    // console.log(error?.response?.data);
    return Promise.reject(error);
  }
);

// Set interceptors differently for responses
instance.interceptors.response.use(
  (response) => {
    // Edit response config
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
